import { useOverlay, useOverlayActions } from '@store'

import { PaymentPopup } from '../components/PaymentPopup'
import {
  ChapterOverlay,
  DialogOverlay,
  GeneralPopup,
  InfoOverlay,
  ErrorOverlay,
  SoonOverlay,
  TransactionProcessing,
  CurrencyRewardOverlay,
} from './components'
import { AcceptPrivacy } from './components/AcceptPrivacy'
import { NarratorOverlay } from './components/NarratorOverlay'
import { TermsAndPrivacy } from './components/TermsAndPrivacy'
import { DonatePopup } from '../components/DonatePopup/DontatePopup'
import { DonateRewardPopup } from '../components/DonateRewardPopup/DonateRewardPopup'
import { HintPaymentPopup } from '../components/HintPaymentPopup'
import { RefillPopup } from './components/RefillPopup/RefillPopup'
import { NewQuestPopup } from './components/NewQuestPopup/NewQuestPopup'

export const OverlayRenderer = () => {
  const overlay = useOverlay((s) => s.overlay)
  const { hideOverlay } = useOverlayActions()

  if (!overlay) return null

  switch (overlay.type) {
    case 'transactionProcessing':
      return <TransactionProcessing />
    case 'acceptPrivacy':
      return <AcceptPrivacy />
    case 'termsAndPrivacy':
      return <TermsAndPrivacy {...overlay.payload} />
    case 'soon':
      return <SoonOverlay />
    case 'dialog':
      return <DialogOverlay {...overlay.payload} />
    case 'chapter':
      return <ChapterOverlay {...overlay.payload} />
    case 'narrator':
      return <NarratorOverlay {...overlay.payload} />
    case 'achievement':
      return <GeneralPopup {...overlay.payload} />
    case 'battlePass':
      return <GeneralPopup {...overlay.payload} />
    case 'info':
      return <InfoOverlay {...overlay.payload} />
    case 'error':
      return <ErrorOverlay {...overlay.payload} />
    case 'item':
      return <GeneralPopup {...overlay.payload} />
    case 'payment':
      return <PaymentPopup item={overlay.payload.item} onClose={hideOverlay} />
    case 'donate':
      return <DonatePopup onClose={hideOverlay} />
    case 'donateReward':
      return <DonateRewardPopup onClose={hideOverlay} onConfirm={overlay.payload.onConfirm} />
    case 'refill':
      return <RefillPopup onClose={hideOverlay} />
    case 'openNewQuest':
      return <NewQuestPopup {...overlay.payload} />
    case 'currencyReward':
      return <CurrencyRewardOverlay {...overlay.payload} />
    case 'hintPayment':
      return <HintPaymentPopup {...overlay.payload} />
    default:
      return null
  }
}
